import React, { useState } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText,
  makeStyles,
  Drawer,
  
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';

const DrawerComponent = () => {
  const useStyles = makeStyles(theme => ({
    drawerContainer: {},
    iconButtonContainer: {
      marginLeft: 'auto',
      color: 'white',
    },

    menuIconToggle: {
      fontSize: '3rem',
    },
  }));

  const [openDrawer, setOpenDrawer] = useState(false);

  //Css
  const classes = useStyles();
  return (
    <>
      <Drawer
        anchor='top'
        classes={{ paper: classes.drawerContainer }}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        onOpen={() => setOpenDrawer(true)}>
        <List>
          <ListItem component={Link} to="/profile" divider button onClick={() => setOpenDrawer(false)}>
            <ListItemIcon >
              <ListItemText > Profile</ListItemText>
            </ListItemIcon>
          </ListItem>

          <ListItem component={Link} to="/new" divider button onClick={() => setOpenDrawer(false)}>
            <ListItemIcon>
              <ListItemText> New</ListItemText>
            </ListItemIcon>
          </ListItem>

          <ListItem component={Link} to="/login" divider button onClick={() => setOpenDrawer(false)}>
            <ListItemIcon>
              <ListItemText>LogIn</ListItemText>
            </ListItemIcon>
          </ListItem>
          <ListItem component={Link} to="/register" divider button onClick={() => setOpenDrawer(false)}>
            <ListItemIcon>
              <ListItemText>Register</ListItemText>
            </ListItemIcon>
          </ListItem>

        </List>
      </Drawer>
      {/* Since this is inside our toolbar we can push it to the end of the toolbar */}
      <IconButton
        className={classes.iconButtonContainer}
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple>
        <MenuIcon className={classes.menuIconToggle} />
      </IconButton>
    </>
  );
};

export default DrawerComponent;